import { setTerms } from './helpers';

export const setCoworkingIds = setTerms('coworking_id');
